import React from 'react';
import { PageLayout, Navbar } from '~/components';

import PatientsAddForm from '~/components/Patient/Add/Form';

const PatientsAdd = () => (
  <PageLayout
    title="Add Patient"
    Header={Navbar}
  >
    <PatientsAddForm />
  </PageLayout>
);

export default PatientsAdd;
